<ng-container *ngIf="chatController.activeManager$ | async as manager">

    <div class="header">
        <div class="header-label-container">
            <ng-container *ngIf="{ session: manager.activeSession$ | async, state: manager.state$ | async } as header">
                <button ui-kit buttonFunction
                    *ngIf="(header.session || header.state?.status === 'error') && !header.state?.hideHeaderBack"
                    iconName="arrow-left-2"
                    color="accent"
                    size="medium"
                    (click)="manager.closeSession()">
                </button>
            </ng-container>
            <div class="label">{{ manager.template.config.title }}</div>
            <div class="actions">
                <button ui-kit buttonFunction 
                    iconName="cross" 
                    color="neutral" 
                    size="medium" 
                    (click)="closed.emit()">
                </button>
            </div>
        </div>
        <div class="header-tabs-container">
            <tabs-header
                *ngIf="chatController.managers.length > 1 && !(manager.activeSession$ | async)"
                ui-kit
                class="chat-tabs-header"
                [tabsContent]="tabsContent"
                headerSeverity="primary"
                headerSize="small"
            ></tabs-header>
        </div>
    </div>
    <div class="content">
          <tabs-content ui-kit #tabsContent class="chat-tabs-content">
            <tab ui-kit *ngFor="let m of chatController.managers" [label]="m.label">
                <ng-template>
                    <chat-manager-view
                        [manager]="m"
                        [restoreScrollTop]="restoreScrollTop"
                        (scrollPositionChange)="scrollPositionChange.emit($event)"
                        class="chat-manager-slot"
                    ></chat-manager-view>
                </ng-template>
            </tab>
        </tabs-content>
    </div>
</ng-container>

<div *ngIf="isDraggingFiles" class="file-drop-zone" aria-hidden="true">
    <div class="file-drop-zone__content">
        <icon ui-kit name="file" size="size-4xl" color="icon-accent-default"></icon>
        <div class="file-drop-zone__title">Перетащите файлы сюда</div>
        <div class="file-drop-zone__caption">Они будут прикреплены к сообщению</div>
    </div>
</div>
